// material-ui
import { Box, Button, Grid, Typography, Modal, TextField, Select, MenuItem, CircularProgress } from '@mui/material';
import { Cancel, KeyOutlined } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';

import { successAlert, warningAlert, errorAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';

import { useTranslation } from "react-i18next";
import { display } from '@mui/system';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdateCustomerPermissionModal = ({
    updateCustomerPermissionModalOpen,
    setUpdateCustomerPermissionModalOpen,
    customerRow,
    fetchCustomers,
    isActualAccount,
    isAllowToTakeTask,
    isAllowToCompleteTask,
    isAllowToWithdrawWithoutTask,
    isAllowToWithdraw,
    isAllowToWithdrawWhenPresetTask,
    isAllowToUseReferralCode,
    handleRefresh,
    isUnconditionalWithdrawalAllowed
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    const [customerID, setCustomerID] = useState(0);
    
    useEffect(() => {
        if (updateCustomerPermissionModalOpen && customerRow?.id) {
            setCustomerID(customerRow.id);
            console.log('customerRow.id', customerRow.id);
        }
    }, [updateCustomerPermissionModalOpen, customerRow]);

    const submitCustomerPassword = async () => {
        setUpdateBtnDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/CustomerDetailsPermission',
                {
                    customerID: customerID,
                    isActualAccount: isActualAccount,
                    isAllowToTakeTask: isAllowToTakeTask,
                    isAllowToCompleteTask: isAllowToCompleteTask,
                    isAllowToWithdrawWithoutTask: isAllowToWithdrawWithoutTask,
                    isAllowToWithdraw: isAllowToWithdraw,
                    isAllowToWithdrawWhenPresetTask: isAllowToWithdrawWhenPresetTask,
                    isAllowToUseReferralCode: isAllowToUseReferralCode,
                    isUnconditionalWithdrawalAllowed: isUnconditionalWithdrawalAllowed
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功更新当前设置');
                // fetchCustomers();
                handleRefresh();
                setUpdateCustomerPermissionModalOpen(false);
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateBtnDisabled(false);
        }
    };

    return (
        <div>
            <Modal open={updateCustomerPermissionModalOpen} onClose={() => setUpdateCustomerPermissionModalOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: '25px',
                                whiteSpace: 'nowrap',
                                textAlign: 'center',
                                marginTop: '30px'
                            }}
                        >
                            {t("customer.confirmUpdateCurrentSetting")} ?
                        </Typography>
                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '30px'
                                }}
                                onClick={submitCustomerPassword}
                                disabled={updateBtnDisabled}
                            >
                                {t("customer.confirm")}
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: 'grey',
                                    marginTop: '30px'
                                }}
                                onClick={() => setUpdateCustomerPermissionModalOpen(false)}
                                disabled={updateBtnDisabled}
                            >
                                {t("customer.cancel")}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default UpdateCustomerPermissionModal;
